import { useState } from 'react';
import { handleTrack } from '../../../../utils/tracker';
import { If } from '../../../Atoms/Conditionals';
import { CloseIcon, SearchIcon } from '../../../Icons';
import { TabBarWithRender } from '../../../income-tax/page-sections/tabs/TabPanel';
import { BrokerList } from '../Brokers';

export const FilterSection = (): JSX.Element => {
  const [searchkey, setsearchKey] = useState('');
  const [exchangeFilter, setExchangefilter] = useState('all');

  const handleSearch = (searchTerm = { value: '' }) => {
    setsearchKey(searchTerm.value);
  };

  const updateFilter = (filter: string) => {
    setExchangefilter(filter);
    handleTrack({ label: `${filter}_tab_button` });
  };

  const getFilteredTabBrokerList = () => (
    <div className="wg-container">
      <BrokerList searchKey={searchkey} exchangeFilter={exchangeFilter} />
    </div>
  );

  const tabsArray = [
    {
      id: 'all',
      title: 'All',
      render: getFilteredTabBrokerList,
    },
    {
      id: 'indian',
      title: 'Indian Stocks',
      render: getFilteredTabBrokerList,
    },
    {
      id: 'crypto',
      title: 'Crypto',
      render: getFilteredTabBrokerList,
    },
    {
      id: 'foreign',
      title: 'Foreign Stocks',
      render: getFilteredTabBrokerList,
    },
  ];

  return (
    <>
      <div className="wg-container -mt-7">
        <div className="relative w-7/12 mx-auto md:w-full sm:w-full">
          <SearchIcon color="#92959A" className="mx-1 absolute ml-4 top-4" />
          <input
            className="w-full outline-[#EBEBEC] outline-1 pl-14 py-4 border-[#EBEBEC] border-xs rounded-md"
            type="text"
            placeholder="Search your Exchange/Wallet/Blockchain/Service. Eg: Coinbase, Bitcoin, etc.."
            value={searchkey}
            maxLength={40}
            onClick={() => {
              handleTrack({ label: 'searchbar_inputButton_Search here' });
            }}
            onChange={({ target }) => handleSearch(target)}
          />

          <If condition={!!searchkey}>
            <div
              className="mx-1 absolute top-4 right-1 ml-2  "
              onClick={() => setsearchKey('')}
            >
              <CloseIcon />
            </div>
          </If>
        </div>
      </div>

      <div className="w-full mx-2 mt-12 sm:mt-8" data-testid="button-group">
        <TabBarWithRender
          tabs={tabsArray}
          defaultSelectedIndex={0}
          trackLabel={'ads'}
          onClickHandler={({ target }) =>
            updateFilter((target as HTMLElement).id)
          }
        />
      </div>
    </>
  );
};
